import React, { Fragment, useContext, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import Button from "../../lib/ui/buttons/Button";
import InputField from "../../lib/ui/inputs/Input";
import DropDown from "../../lib/ui/dropdown/Dropdown";
// import Radio from "../../lib/ui/radio/Radio";
// import PhoneInput, { isValidPhoneNumber, parsePhoneNumber } from "react-phone-number-input";
import LogoBranding from "../../lib/ui/logoBranding/LogoBranding";
import { LangCtx } from "../../lib/context";
import { langObj } from "../../locale/index";
import "react-phone-number-input/style.css";
import "../../lib/ui/imageicon/Styles.css";
import "../../lib/ui/inputs/InputStyles.css";
import "../../layouts/Layouts.css";
import "../../ui-styles/picker/picker.css";
// import DateFnsUtils from "@date-io/date-fns";
// import titlesList from "../../config/titles.json";
// import statesList from "../../config/states.json";
// import citiesList from "../../config/cities.json";
// import titlesList from "../../config/titles.json";
// import countriesList from "../../config/countries.json";
// import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import {
    // validateDate,
    // validateDob,
    validateEmail,
    validateLetters,
    // validatePassword,
    // validatePincode,
    // validateKeys,
    // validateIntegers,
    // validateCharecters,
    validateDomain,
} from "../../lib/validation";

// import { patientsignup } from "../../actions/users";
// import config from "../../config.json";
// import { dateFormat } from "../../lib/functions";
// import AddrDropDown from "../../lib/ui/dropdown/addressDropDown";
// import { Auth, API } from "aws-amplify";
import Loader from "../../lib/ui/loader/Loader";
// import bloodgroups from "../../config/bloodgroup.json";
import { createClinic } from "../../actions/users";

import { toast } from "react-toastify";
// import Loading from "../../components/loading";
import { DataDefault } from "../../actions/configuration";
import PlayCircleFilledWhiteIcon from "@material-ui/icons/PlayCircleFilledWhite";
import { Checkbox, FormControlLabel } from "@material-ui/core";
import { getSubdomain } from "../../lib/domain";
// const psl = require("psl");
// const { parseDomain } = require("parse-domain");

window.Cookies = require("js-cookie");

//const titlesList = [{value: "", label:"Select"},{ value: "Mr", label: "Mr." }, { value: "Mrs", label: "Mrs." }, { value: "Ms", label: "Ms." }, { value: "Master", label: "Master" }, { value: "Miss", label: "Miss" }]
const ClinicSignupPage = (props) => {
    const { l, setLang } = useContext(LangCtx);
    // const { custom } = useContext(CustomCtx);
    const history = useHistory();
    const { cId, role } = props;
    const langOptions = [
        { value: "en", label: l.english },
        { value: "hi", label: l.hindi },
        { value: "fr", label: l.french },
    ];

    // const [numfrmpath, setdocfrompath] = useState(
    //     props && props.history && props.history.location && props.history.location.state && props.history.location.state.docnum
    // );

    const [loading, setLoading] = useState(false);
    // const { ref } = useParams();
    const [errorMsg, setErrorMsg] = useState(null);
    const [error, setError] = useState({});
    const [clinicName, setClinicName] = useState("");
    const [contactName, setContactName] = useState("");
    const [email, setEmail] = useState("");
    // const [phone, setPhone] = useState("");
    // const [username, setUsername] = useState("");
    // const [pincode, setPincode] = useState("");
    // const [doctorCount, setDoctorCount] = useState("");
    // const [address, setAddress] = useState("");
    // const [confirmpassword, setConfirmPassword] = useState("");
    // const [states, setStates] = useState([
    //     {
    //         value: "",
    //         label: l.select_state,
    //     },
    // ]);
    // const [cities, setCities] = useState([
    //     {
    //         value: "",
    //         label: l.select_city,
    //     },
    // ]);
    // const [country, setCountry] = useState("India");
    // const [state, setState] = useState("");
    // const [city, setCity] = useState("");
    // const [password, setPassword] = useState("");
    const [admins, setAdmins] = useState([]);
    const [assignTo, setAssign] = useState("");
    const [domainName, setDomainName] = useState("");
    // const [doctorsCount, setDoctorsCount] = useState(numfrmpath);
    const [signupFieldsData, setSignupFieldsData] = useState({ checkedFirst: false, checkedSecond: false })
    // const [poolId, setPoolId] = useState("");
    // const [identityId, setIdentityId] = useState("");
    // const [appClientId, setAppClientId] = useState("");

    const qty = window.location.search.split("/")[3];

    const searchParams = new URLSearchParams(window.location.search);

    const referral = searchParams.get("ref");

    // const _domain = psl.parse(window.location.hostname);
    const _domain = getSubdomain(window.location.hostname);


    const handleLang = (e) => {
        setLang(langObj[e.target.value]);
        localStorage.setItem("lang", e.target.value);
    };

    // useEffect(() => {
    //     let _statesList = statesList.filter((state) => state.countryid === country);
    //     _statesList.unshift({
    //         value: "",
    //         label: l.select_state,
    //     });
    //     _statesList.sort((a, b) => (a.value < b.value ? -1 : a.value > b.value ? 1 : 0));
    //     setStates([..._statesList]);
    // }, [country]);

    // useEffect(() => {
    //     let _citiesList = citiesList.filter((city) => city.stateid === state);
    //     _citiesList.unshift({
    //         value: "",
    //         label: l.select_city,
    //     });
    //     _citiesList.sort((a, b) => (a.value < b.value ? -1 : a.value > b.value ? 1 : 0));
    //     setCities(_citiesList);
    // }, [state]);

    const validateForm = () => {
        let _error = {};
        let returnValue = true;

        if (!signupFieldsData.checkedFirst) {
            _error["checkedFirst"] = true;
            returnValue = false;
        }

        if (!signupFieldsData.checkedSecond) {
            _error["checkedSecond"] = true;
            returnValue = false;
        }

        if (clinicName === "" || clinicName == null) {
            _error["clinicName"] = l.pls_ent_clcName;
            returnValue = false;
        } else if (!validateLetters(clinicName)) {
            _error["clinicName"] = l.pls_ent_clc_contact;

            returnValue = false;
        }
        if (contactName === "" || contactName == null) {
            _error["contactName"] = l.pls_ent_contName;
            returnValue = false;
        } else if (!validateLetters(contactName)) {
            _error["contactName"] = l.pls_ent_clc_contact;
            returnValue = false;
        }
        if (email === "" || email == null) {
            _error["email"] = l.pls_enter_email;
            returnValue = false;
        } else if (!validateEmail(email)) {
            _error["email"] = l.pls_check_email;
            returnValue = false;
        }
        // if (phone === "" || phone == null) {
        //     _error["phone"] = l.pls_enter_phone;
        //     returnValue = false;
        // } else if (!isValidPhoneNumber(phone)) {
        //     _error["phone"] = l.pls_check_phone;
        //     returnValue = false;
        // }
        // if (country === "" || country == null) {
        //     _error["country"] = l.pls_sel_country;
        //     returnValue = false;
        // }
        // if (state === "" || state == null) {
        //     _error["state"] = l.pls_sel_state;
        //     returnValue = false;
        // }
        // if (city === "" || city == null) {
        //     _error["city"] = l.pls_sel_city;
        //     returnValue = false;
        // }
        // if (pincode === "" || pincode === null) {
        //     _error["pincode"] = l.pls_entr_pin;
        //     returnValue = false;
        // } else if (!validatePincode(pincode)) {
        //     _error["pincode"] = l.pls_check_pin;
        //     returnValue = false;
        // }

        if (domainName === "" || domainName === null) {
            _error["domainName"] = l.pls_entr_domain;
            returnValue = false;
        } else if (!validateDomain(domainName)) {
            _error["domainName"] = l.pls_check_domain;
            returnValue = false;
        }

        // if (password === '') {
        //     _error['password'] = l.pls_ent_new_pwd
        //     returnValue = false
        // }
        // else if (password !== '' &&  !validatePassword(password)) {
        //     _error['password'] = l.ent_valid_pwd
        //     returnValue = false
        // }
        // if(confirmpassword === ''){
        //     _error['confirmpassword'] = l.pls_ent_conf_pwd
        //     returnValue = false
        // }
        // else if(confirmpassword !== '' && !validatePassword(confirmpassword)){
        //     _error['confirmpassword'] = l.ent_valid_confPwd
        //     returnValue = false
        // }

        // if(password !== confirmpassword){
        //     _error['confirmpassword'] = l.psw_confpsw_should_same
        //     returnValue = false
        // }

        // if (!cId && domainName !== config.defaultdomian && (poolId === '' || poolId === null)) {
        //     _error['poolId'] = l.pls_entr_pool_id
        //     returnValue = false
        // } else if (!cId && domainName !== config.defaultdomian && poolId !== "" && !validateKeys(poolId)) {
        //     _error['poolId'] = l.pls_ent_valid_pool_id
        //     returnValue = false
        // }

        // if (!cId && domainName !== config.defaultdomian && (identityId === '' || identityId === null)) {
        //     _error['identityId'] = l.pls_entr_identity_pool_id
        //     returnValue = false
        // } else if (!cId && domainName !== config.defaultdomian && identityId !== "" && !validateKeys(identityId)) {
        //     _error['identityId'] = l.pls_ent_valid_ide_pool_id
        //     returnValue = false
        // }

        // if (!cId && domainName !== config.defaultdomian && (appClientId === '' || appClientId === null)) {
        //     _error['appClientId'] = l.pls_entr_app_client_id;
        //     returnValue = false
        // } else if (!cId && domainName !== config.defaultdomian && appClientId !== "" && !validateKeys(appClientId)) {
        //     _error['appClientId'] = l.pls_ent_valid_app_client_id
        //     returnValue = false
        // }
        // if (doctorsCount === "" || doctorsCount === null) {
        //     _error["doctorsCount"] = l.pls_enter_doctors;
        //     returnValue = false;
        // }
        // if (assignTo === '' || assignTo === null) {
        //     _error['assignTo'] = l.pls_selt_admin
        //     returnValue = false
        // }
        // if (doctorsCount === "" || doctorsCount === null) {
        //     _error["doctorsCount"] = l.pls_entr_dctrcount;
        //     returnValue = false;
        // } else if (!validateIntegers(doctorsCount) || doctorsCount > 100 || doctorsCount < 1) {
        //     _error["doctorsCount"] = l.pls_check_dctrcount;
        //     returnValue = false;
        // }

        setError(_error);
        console.log("error in clinicform", _error);
        return returnValue;
    };

    const handleCreateClinic = async (e) => {
        e.preventDefault();
        try {
            if (validateForm()) {
                setErrorMsg("");
                setLoading(true);
                // const phoneNumber = parsePhoneNumber(phone);
                // const countrycode = phoneNumber.countryCallingCode;
                // const number = phoneNumber.nationalNumber;
                let body = {
                    clinicName: clinicName.trim(),
                    firstName: clinicName.trim(),
                    lastName: "",
                    consultRole: "clinic",
                    contactName: contactName.trim(),
                    email: email.replaceAll(" ", "").toLowerCase(),
                    countryCode: "",
                    phone: "",
                    address: "",
                    country: "",
                    stateName: "",
                    city: "",
                    pincode: "",
                    doctorsCount: "",
                    doctorPrivligies: {},
                    //     advice: advice,
                    //     uploadPrescription: uploadPrescription,
                    //     prescription: prescription
                    // },
                    // patientPriviligies: {
                    //     screenShare: screenShare
                    // },
                    adminId: assignTo,
                    subdomain: domainName.toLowerCase(),
                };
                if (window.location.search.split("/")[2] === "INVCFREE") {
                    body["isFree"] = true;
                }

                // const referral = window.Cookies.get("inclinicreferrer");

                if (referral && referral !== undefined && referral !== "") {
                    body["referral"] = referral;
                }

                setLoading(true);
                createClinic(body)
                    .then(async (res) => {
                        // setLoading(false);
                        if (res.status) {
                            // toast.success("Clinic created successfully", {
                            //     position: toast.POSITION.TOP_RIGHT
                            // })
                            //history.push('/place-your-order/:productCode/:defaultQty');
                            //history.push('/place-your-order?qty='+doctorsCount);

                            const Dbody = { userId: res?.data?.userId };
                            await DataDefault(Dbody)
                                .then((res) => {
                                    setLoading(false);
                                    toast.success("SignUp Successfully", {
                                        position: toast.POSITION.TOP_RIGHT,
                                    });

                                })
                                .catch((err) => console.log(err));


                            if (window.location.search.split("/")[2] === "INVCCCP") {
                                history.push(`/place-your-order/INVCCCP/${qty}?username=${body?.email}&subdomain=${body?.subdomain}`);
                                setLoading(false);
                            } else {
                                window.open(`https://${res?.data?.subdomain}${process.env.REACT_APP_domainURL}`, "_self");
                                setLoading(false);
                            }
                            setLoading(false);
                            // if (url === "INVCCCP") {
                            //     history.push({
                            //         pathname: `/place-order/INVCCCP/${qty}?phone=${body?.phone}&subdomain=${body?.subdomain}`,
                            //         // search: "?productCode=INVCFREE",
                            //         // state: { clinic_body: body, qty: qty, productCode: "INVCCCP" },
                            //     });
                            // } else if (url === "INVCFREE") {
                            //     history.push({
                            //         pathname: `/place-order/INVCFREE/5?phone=${body?.phone}&subdomain=${body?.subdomain}`,
                            //         // search: "?productCode=INVCFREE",
                            //         // state: { clinic_body: body, qty: 5, productCode: "INVCFREE" },
                            //     });
                            // } else {
                            //     history.push({
                            //         pathname: `/place-order/INVCCCP/${doctorsCount}?phone=${body?.phone}&subdomain=${body?.subdomain}`,
                            //         // search: "?productCode=INVCFREE",
                            //         // state: { clinic_body: body, qty: doctorsCount, productCode: "INVCCCP" },
                            //     });
                            // }

                            // history.push({
                            //     pathname: "/place-order/INVCCCP/5",
                            //     // search: "?productCode=INVCFREE",
                            //     state: { clinic_body: body, qty: doctorsCount, productCode: "INVCCCP" },
                            // });
                            // history.push("/place-your-order/INVCFREE/5");
                        }
                    })
                    .catch((err) => {
                        setLoading(false);
                        console.log("error in create user=======", err);
                        let msg = err?.response?.data?.error?.message
                            ? err.response.data.error.message
                            : err?.response?.data?.error
                                ? err.response.data.error
                                : l.unable_crt_clinic;

                        toast.error(msg, {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                        setErrorMsg(msg);
                        setLoading(false);
                    });
            } else {
                if (errorMsg != null) {
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                    });
                }
            }
        } catch (err) {
            setLoading(false);
            let msg = err?.response?.data?.error ? err.response.data.error : err.errorMessage;
            toast.error(msg, {
                position: toast.POSITION.TOP_RIGHT,
            });

            setErrorMsg(l.went_worng_pls_try_again);
        }
    };

    return (
        <Fragment>
            {loading && <Loader />}
            <div className="coverContainer">
                <div className="outSideContainer">
                    <div className="colCredential">
                        <div className="topRow pdngHMD">
                            <div className="langBlock">
                                {_domain?.subdomain === process.env.REACT_APP_defaultdomian && <div className="helpBtn DeskDisplayorNot">
                                    <a
                                        className="logintollfree flexInline alignCntr"
                                        href="https://help.instavc.com/inclinic"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <PlayCircleFilledWhiteIcon className="callIcon" fontSize="small" />
                                        {l.help_center}
                                    </a>
                                </div>}
                                {/* <div className="helpBtn mobDisplayorNot">
                                    <a
                                        className="logintollfree flexInline alignCntr"
                                        href="https://help.instavc.com/inclinic"
                                        target="_blank"
                                    >
                                        <PlayCircleFilledWhiteIcon className="callIcon" fontSize="small" />
                                        {l.help}
                                    </a>
                                </div> */}
                                <DropDown
                                    placeholder="Languages"
                                    items={langOptions}
                                    value={localStorage.getItem("lang") ? localStorage.getItem("lang") : l.locale}
                                    onChange={handleLang}
                                />
                            </div>
                        </div>
                        <div className="bodyRow">
                            <div className="brandingBlock">
                                <LogoBranding />
                            </div>
                            <div className="crdFormBlock">
                                <div className="crdHeadingBlock justifyCenter">
                                    <h2 className="headingTxt">{l.clinic_signup}</h2>
                                </div>

                                {errorMsg && errorMsg !== "" && (
                                    <div className="errorBox">
                                        <small className="errorTxt">{errorMsg}</small>
                                    </div>
                                )}

                                <div className="colBlock">
                                    <form>
                                        <small className="inpLabel">
                                            {l.edit_clc_name}
                                            <span className="redTxt">*</span>:
                                        </small>
                                        <InputField
                                            placeholder={l.edit_clc_name}
                                            type="text"
                                            value={clinicName}
                                            error={error && error.clinicName}
                                            errorMsg={error.clinicName}
                                            maxLength="30"
                                            onChange={(e) => setClinicName(e.target.value)}
                                        />
                                        <small className="inpLabel">
                                            {l.edit_clc_contact_name}
                                            <span className="redTxt">*</span>:
                                        </small>
                                        <InputField
                                            placeholder={l.edit_clc_contact_name}
                                            type="text"
                                            value={contactName}
                                            error={error && error.contactName}
                                            errorMsg={error.contactName}
                                            maxLength="30"
                                            onChange={(e) => setContactName(e.target.value)}
                                        />
                                        <small className="inpLabel">
                                            {l.email_address}
                                            <span className="redTxt">*</span>:
                                        </small>
                                        <InputField
                                            placeholder={l.email_address}
                                            type="text"
                                            value={email?.replaceAll(" ", "").toLowerCase()}
                                            error={error && error.email}
                                            errorMsg={error.email}
                                            maxLength="50"
                                            onChange={(e) => setEmail(e.target.value)}
                                        />
                                        {/* {cId ? (
                                            ""
                                        ) : (
                                            <Fragment>
                                                <small className="inpLabel">
                                                    {l.edit_phone_no}
                                                    <span className="redTxt">*</span>:
                                                </small>
                                                <div className="inputBox colBlock nopdng">
                                                    <PhoneInput
                                                        className="customPkgInput"
                                                        international
                                                        countryCallingCodeEditable={false}
                                                        defaultCountry="IN"
                                                        value={phone}
                                                        maxLength="17"
                                                        error={error && error.phone}
                                                        errorMsg={error.phone}
                                                        onChange={setPhone}
                                                    />
                                                    <label>{props.label}</label>
                                                    {error && error.phone && <span className="inputErrorMsg">{error.phone}</span>}
                                                </div>
                                            </Fragment>
                                        )} */}
                                        {/* <small className="inpLabel">{l.edit_address}:</small>
                                        <InputField
                                            placeholder={l.edit_address}
                                            type="text"
                                            value={address}
                                            error={error && error.address}
                                            errorMsg={error.address}
                                            maxLength="100"
                                            onChange={(e) => setAddress(e.target.value)}
                                        />
                                        <small className="inpLabel">
                                            {l.select_country}
                                            <span className="redTxt">*</span>:
                                        </small>
                                        <AddrDropDown
                                            placeholder={l.select_country}
                                            items={countriesList}
                                            value={country}
                                            error={error && error.country}
                                            errorMsg={error.country}
                                            onChange={(e) => setCountry(e.target.value)}
                                        />
                                        <div className="rowBlock">
                                            <div className="inputRowGroup mrgRight8">
                                                <small className="inpLabel">
                                                    {l.select_state}
                                                    <span className="redTxt">*</span>:
                                                </small>
                                                <AddrDropDown
                                                    placeholder={l.select_state}
                                                    items={states}
                                                    value={state}
                                                    error={error && error.state}
                                                    errorMsg={error.state}
                                                    onChange={(e) => setState(e.target.value)}
                                                />
                                            </div>
                                            <div className="inputRowGroup ">
                                                <small className="inpLabel">
                                                    {l.select_city}
                                                    <span className="redTxt">*</span>:
                                                </small>
                                                <AddrDropDown
                                                    placeholder={l.select_city}
                                                    items={cities}
                                                    value={city}
                                                    error={error && error.city}
                                                    errorMsg={error.city}
                                                    onChange={(e) => setCity(e.target.value)}
                                                />
                                            </div>
                                        </div> */}
                                        {/* <small className="inpLabel">
                                            {l.edit_pin}
                                            <span className="redTxt">*</span>:
                                        </small>
                                        <InputField
                                            placeholder={l.edit_pin}
                                            type="text"
                                            maxLength={8}
                                            value={pincode}
                                            error={error && error.pincode}
                                            errorMsg={error.pincode}
                                            onChange={(e) => setPincode(e.target.value)}
                                        /> */}
                                        <small className="inpLabel">
                                            {l.edit_clc_domain_name}
                                            <span className="redTxt">*</span>: (Ex: yourdomainname{process.env.REACT_APP_domainURL})
                                        </small>
                                        <div className="inputDefaultTxtBlock">
                                            <InputField
                                                placeholder="yourdomainname"
                                                type="text"
                                                error={error && error.domainName}
                                                errorMsg={error.domainName}
                                                maxLength={15}
                                                value={domainName}
                                                onChange={(e) => setDomainName(e.target.value)}
                                            />
                                            <span className="domainName">{process.env.REACT_APP_domainURL}</span>
                                        </div>
                                        {/* {domainName !== config.defaultdomian && !cId && <Fragment>
                                        <small className="inpLabel">{l.congnito_pool_id}<span className="redTxt">*</span>:</small>
                                        <InputField
                                            placeholder={l.congnito_pool_id}
                                            type="text"
                                            value={poolId}
                                            error={error && error.poolId}
                                            errorMsg={error.poolId}
                                            onChange={(e) => setPoolId(e.target.value)}
                                        />
                                        <small className="inpLabel">{l.congnito_identity_pool_id}<span className="redTxt">*</span>:</small>
                                        <InputField
                                            placeholder={l.congnito_identity_pool_id}
                                            type="text"
                                            value={identityId}
                                            error={error && error.identityId}
                                            errorMsg={error.identityId}
                                            onChange={(e) => setIdentityId(e.target.value)}
                                        />
                                        <small className="inpLabel">{l.app_client_id}<span className="redTxt">*</span>:</small>
                                        <InputField
                                            placeholder={l.app_client_id}
                                            type="text"
                                            value={appClientId}
                                            error={error && error.appClientId}
                                            errorMsg={error.appClientId}
                                            onChange={(e) => setAppClientId(e.target.value)}
                                        />
                                    </Fragment>
                                    } */}
                                        {/* <small className="inpLabel">{l.numb_doctors}<span className="redTxt">*</span>:</small>
                                <InputField
                                    placeholder={l.numb_doctors}
                                    type="text"
                                    value={doctorCount}
                                    onChange={(e) => setDoctorCount(e.target.value)}
                                /> */}
                                        {/* <small className="inpLabel">
                                            {l.numb_doctors}
                                            <span className="redTxt">*</span>:
                                        </small>
                                        <InputField
                                            placeholder={l.numb_doctors}
                                            type="number"
                                            value={doctorsCount}
                                            pattern="[0-9]{4}"
                                            error={error && error.doctorsCount}
                                            errorMsg={error.doctorsCount}
                                            onChange={(e) => setDoctorsCount(e.target.value)}
                                        /> */}
                                        {role === "SA" && !cId && (
                                            <Fragment>
                                                <small className="inpLabel">
                                                    {l.ass_to}
                                                    <span className="redTxt">*</span>:
                                                </small>
                                                <DropDown
                                                    placeholder={l.ass_to}
                                                    items={admins}
                                                    value={assignTo}
                                                    error={error && error.assignTo}
                                                    errorMsg={error.assignTo}
                                                    onChange={(e) => setAssign(e.target.value)}
                                                />
                                            </Fragment>
                                        )}

                                        {/* <small className="inpLabel">{l.pass}<span className="redTxt">*</span>:</small>
                                <InputField
                                    placeholder={l.pass}
                                    type="password"
                                    value={password}
                                    error={error && error.password}
                                    errorMsg={error.password}
                                    showPwd={true}
                                    maxLength="30"
                                    onChange={(e) => setPassword(e.target.value)}
                                /> */}
                                        {/* <span className="smallPTxt">{l.pwd_security}</span> */}

                                        {/* <small className="inpLabel">{l.confirm_pwd}<span className="redTxt">*</span>:</small>
                                <InputField
                                    placeholder={l.confirm_pwd}
                                    type="password"
                                    value={confirmpassword}
                                    error={error && error.confirmpassword}
                                    errorMsg={error.confirmpassword}
                                    showPwd={true}
                                    maxLength="30"
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                />       */}
                                        {/* <span className="smallPTxt">{l.pwd_security}</span> */}
                                    </form>
                                    <div className="flexCol mrgnTSM">
                                        <FormControlLabel
                                            className='rBox'
                                            control={
                                                <Checkbox
                                                    style={{ paddingTop: "0px" }}
                                                    name="checkedFirst"
                                                    color="primary"
                                                    checked={signupFieldsData.checkedFirst}
                                                    onChange={(e) =>
                                                        setSignupFieldsData((prevState) => ({
                                                            ...prevState,
                                                            checkedFirst: e && e.target && e.target.checked ? e.target.checked : false,
                                                        }))
                                                    }
                                                />
                                            }
                                            label={
                                                <span>
                                                    By Submitting this form you agree to <strong>InstaVC</strong>{" "}
                                                    <a
                                                        href="https://www.instavc.com/en-in/privacy-policy/"
                                                        style={{ color: "#01A2C4", textDecoration: "underline" }}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        data-cmp-ab="2"
                                                    >
                                                        Privacy Policy
                                                    </a>.
                                                </span>
                                            }
                                        />

                                        {error.checkedFirst && <span className="inputErrorMsg">If you wish to proceed, please mark the checkbox.</span>}

                                        <FormControlLabel
                                            className='rBox'
                                            control={
                                                <Checkbox
                                                    style={{ paddingTop: "0px" }}
                                                    name="checkedSecond"
                                                    color="primary"
                                                    checked={signupFieldsData.checkedSecond}
                                                    onChange={(e) =>
                                                        setSignupFieldsData((prevState) => ({
                                                            ...prevState,
                                                            checkedSecond: e && e.target && e.target.checked ? e.target.checked : false,
                                                        }))
                                                    }
                                                />
                                            }
                                            label={<span className="pvcyplcy"> By clicking I am providing the accurate, updated, and complete information to the best of my knowledge and belief and nothing has been concealed therefrom
                                            </span>}
                                        />
                                    </div>
                                    {error.checkedSecond && <span className="inputErrorMsg">If you wish to proceed, please mark the checkbox.</span>}

                                    <form id="forgotform" onSubmit={handleCreateClinic}>
                                        <div className="crdBtnContainer">
                                            <Button
                                                label={l.create_clinic}
                                                type="primary"
                                                size="md"
                                                fullWidth="fullWidth"
                                                onClick={handleCreateClinic}
                                            />
                                        </div>
                                    </form>
                                    {/* <div className="crdRowBlock mrgTop24">
                                        <small className="pTxt blackInactiveTxt txtCenter">
                                            {l.Copyright}.
                                            I agree to the <a href="https://www.inclinic.vc/terms-and-conditions/" target="_blank" className="linkTxt linkTxtSm">
                                                {" "}
                                                {l.terms_cond}
                                            </a>{" "} */}
                                    {/* {l.and} */}
                                    {/* <Link to="/privacy-policy" target="_blank" className="linkTxt linkTxtSm">
                                                {" "}
                                                {l.privacy_policy}
                                            </Link>{" "} */}
                                    {/* {l.agreeTxt}.
                                        </small>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                        <div className="footerRow">
                            <div className="rowSpaceBtwn">
                                <p className="pTxt mrgRight8">{l.alrdy_have_acct}</p>
                                <Link to="/" className="linkTxt linkTxtMd">
                                    {l.login}
                                </Link>
                            </div>
                            <div className="crdRowBlock  alignCenter justifyCenter">
                                <small className="blackInactiveTxt txtCenter smallTxt">
                                    {l.Copyright}.{l.i_agree_to_the}{" "}
                                    <a href="https://www.inclinic.vc/terms-and-conditions/" target="_blank" className="linkTxt linkTxtSm" rel="noopener noreferrer">
                                        {l.terms_cond}
                                    </a>
                                    {l.agreeTxt}.
                                </small>
                            </div>
                            <small className="smallTxt txtCenter blackInactiveTxt">
                                {l.contact_for}{" "}
                                <a href="https://help.peoplelinkvc.com/portal/en/newticket" target="_blank" className="linkTxt linkTxtSm" rel="noopener noreferrer">
                                    {l.support}
                                </a>
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default ClinicSignupPage;
